<template>
  <div>
    <p class="text-muted small mb-2">
      Nilai constant dipakai sebagai default terkunci untuk field certificate (misal Gembala, IFGF Cabang).
      Mengubah nilai hanya berlaku untuk certificate baru; certificate yang sudah terbit tidak berubah.
      Type "Pastor list" mengambil nilai dari Master Data → Pastors.
    </p>
    <CAlert v-if="message" :color="messageColor" close-button @update:show="message = ''">{{ message }}</CAlert>
    <div v-if="loading" class="text-muted py-3">Loading constants...</div>
    <template v-else-if="!forbidden">
      <div class="table-responsive">
        <table class="table table-sm">
          <thead><tr><th style="width: 18%">Key</th><th style="width: 24%">Label</th><th style="width: 16%">Type</th><th>Value</th><th style="width: 1%"></th></tr></thead>
          <tbody>
            <tr v-for="(row, index) in rows" :key="index">
              <td>
                <code v-if="row.saved">{{ row.key }}</code>
                <input v-else v-model.trim="row.key" class="form-control form-control-sm" placeholder="nama_key">
              </td>
              <td><input v-model="row.label" class="form-control form-control-sm"></td>
              <td>
                <select v-model="row.source" class="form-control form-control-sm">
                  <option value="text">Text</option>
                  <option value="pastor">Pastor list</option>
                </select>
              </td>
              <td>
                <select v-if="row.source === 'pastor'" v-model="row.value" class="form-control form-control-sm">
                  <option value="">(kosong)</option>
                  <option v-if="row.value && !pastorNames.includes(row.value)" :value="row.value">{{ row.value }} (tidak ada di daftar)</option>
                  <option v-for="pastor in pastors" :key="pastor.id" :value="pastor.name">{{ pastor.name }}</option>
                </select>
                <input v-else v-model="row.value" class="form-control form-control-sm" placeholder="(kosong)">
              </td>
              <td><CButton size="sm" color="danger" variant="outline" @click="rows.splice(index, 1)">Remove</CButton></td>
            </tr>
            <tr v-if="!rows.length"><td colspan="5" class="text-muted text-center">No constants yet.</td></tr>
          </tbody>
        </table>
      </div>
      <CButton size="sm" color="info" variant="outline" class="mr-2" @click="addRow">Add Constant</CButton>
      <CButton size="sm" color="success" :disabled="saving" @click="save">{{ saving ? 'Saving...' : 'Save Constants' }}</CButton>
    </template>
  </div>
</template>

<script>
import certificate from '@/services/certificate'

export default {
  name: 'CertificateConstantsEditor',
  data () { return { loading: true, saving: false, forbidden: false, rows: [], pastors: [], message: '', messageColor: 'danger' } },
  computed: {
    pastorNames () { return this.pastors.map(pastor => pastor.name) }
  },
  created () { this.load() },
  methods: {
    setRows (constants) { this.rows = (constants || []).map(item => ({ key: item.key, label: item.label, value: item.value, source: item.source || 'text', saved: true })) },
    async load () {
      this.loading = true
      try {
        // Loaded here, not passed in, because this editor is also used on the System Settings page.
        const [constants, configuration] = await Promise.all([certificate.getConstants(), certificate.getConfiguration()])
        this.pastors = (configuration.data.pastors || []).filter(pastor => pastor.is_active)
        this.setRows(constants.data)
      } catch (error) { this.showError(error) } finally { this.loading = false }
    },
    addRow () { this.rows.push({ key: '', label: '', value: '', source: 'text', saved: false }) },
    async save () {
      this.saving = true
      try {
        const result = await certificate.updateConstants(this.rows.map(({ key, label, value, source }) => ({ key, label, value: value || '', source })))
        this.setRows(result.data)
        this.message = result.message
        this.messageColor = 'success'
        this.$emit('saved', result.data)
      } catch (error) { this.showError(error) } finally { this.saving = false }
    },
    showError (error) {
      const response = error.response
      if (response && response.status === 403) { this.forbidden = true; this.message = 'Anda tidak punya akses "Manage certificate settings" untuk mengubah constant.'; this.messageColor = 'warning'; return }
      const data = response && response.data
      this.message = (data && data.errors && Object.values(data.errors)[0][0]) || (data && data.message) || error.message || 'Request failed.'
      this.messageColor = 'danger'
    }
  }
}
</script>
